import { ConnectionOptions, GraphApiMethod } from '@/api/core';
import { CreateDispatchSummaryInput, CreateDispatchSummaryResponse, MutationCreateDispatchSummaryBulkArgs } from '@/models/gen/graphql';
import createGraphApiHook, { CreateGraphApiHookHook } from '@/hooks/createGraphApiHook';

import { CreateDispatchSummary } from '@/features/SummaryHistory/api/queries/CreateDispatchSummary';
import { TypedDocumentNode } from '@apollo/client';
import { getProperty } from '@/utils';
import graphApi from '@/api';

// Service Function Signature
type ServiceMethodPayload = {
  [key in keyof CreateDispatchSummaryInput]?: any;
}[];
interface ServiceMethod {
  (payload?: ServiceMethodPayload, options?: ConnectionOptions): Promise<CreateDispatchSummaryResponse>;
}

// CreateDispatchSummary Service
export const { createDispatchSummary, useCreateDispatchSummary } = ((): {
  createDispatchSummary: ServiceMethod;
  useCreateDispatchSummary: CreateGraphApiHookHook<ServiceMethod>;
} => {
  const [fetch] = graphApi(CreateDispatchSummary).map(
    (fn: GraphApiMethod<TypedDocumentNode>): ServiceMethod =>
      async (payload?: CreateDispatchSummaryInput[], options?: ConnectionOptions): Promise<CreateDispatchSummaryResponse> => {
        debug.log('createDispatchSummary,createDispatchSummary.input', 'INPUT', payload);
        const values: CreateDispatchSummaryInput[] = payload.map(
          (item: CreateDispatchSummaryInput): CreateDispatchSummaryInput => ({
            callVolume: item?.callVolume || null,
            commentsFaxallCheck: item?.commentsFaxallCheck || null,
            commentsRepeatDistractedOffenders: item?.commentsRepeatDistractedOffenders || null,
            commentsRepeatSpeedingOffenders: item?.commentsRepeatSpeedingOffenders || null,
            dispatcherAssetCamerasWorking: item?.dispatcherAssetCamerasWorking || null,
            dispatcherAssetCamerasWorkingNotes: item?.dispatcherAssetCamerasWorkingNotes || null,
            dispatcherDayOverview: item?.dispatcherDayOverview || null,
            dispatcherEightByEightIssue: item?.dispatcherEightByEightIssue || null,
            dispatcherId: item?.dispatcherId || null,
            dispatcherPassdown: item?.dispatcherPassdown || null,
            dispatcherServiceIssues: item?.dispatcherServiceIssues || null,
            dispatcherShift: item?.dispatcherShift || null,
            dispatcherSoftwareIssues: item?.dispatcherSoftwareIssues || null,
            dispatcherStation: item?.dispatcherStation || null,
            dispatcherStationVansIssues: item?.dispatcherStationVansIssues || null,
            manifestsDrivingIssues: item?.manifestsDrivingIssues || null,
            manifestsTaxis: item?.manifestsTaxis || null,
            manifestsTrainingIssues: item?.manifestsTrainingIssues || null,
            traceId: item?.traceId || null,
            marketComments: item?.marketComments || null,
            chatVolume: item?.chatVolume || null,
            dispatcherWasThereEightByEightIssue: item?.dispatcherWasThereEightByEightIssue || null,
          })
        );
        const args: MutationCreateDispatchSummaryBulkArgs = {
          input: {
            values,
          },
        };
        debug.log('createDispatchSummary,createDispatchSummary.payload', 'PAYLOAD', args);
        const opts = { merge: options?.merge ? 'createDispatchSummaryBulk' : undefined };
        const res = await fn(args, opts);
        debug.log('createDispatchSummary,createDispatchSummary.response', 'RESPONSE', res);
        return getProperty('createDispatchSummaryBulk.output', res);
      }
  );
  const useService = createGraphApiHook(fetch);
  return {
    createDispatchSummary: fetch,
    useCreateDispatchSummary: useService,
  };
})();
